import { render } from "./privatepage.vue?vue&type=template&id=1a7bceee&scoped=true"
import script from "./privatepage.vue?vue&type=script&lang=js"
export * from "./privatepage.vue?vue&type=script&lang=js"

import "flag-icon-css/css/flag-icon.min.css?vue&type=style&index=0&lang=css&external"
import "font-awesome/css/font-awesome.min.css?vue&type=style&index=1&lang=css&external"
import "./privatepage.vue?vue&type=style&index=2&id=1a7bceee&scoped=true&lang=css"
import "./privatepage.vue?vue&type=style&index=3&id=1a7bceee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7bceee"]])

export default __exports__